import { Util } from '@grandvisionhq/forms';
import { useIntl } from '@grandvisionhq/state';

const isPostalCodeValid = (country, postalCode)=>{
    if (!postalCode) return false;
    if (postalCode.charAt(postalCode.length - 1) === ' ') return true;
    return country && postalCode && Util.validations.isValidPostalCodeForCountry(country, postalCode);
};
const useValidateShippingData = ()=>{
    const { getLabel , country  } = useIntl();
    return (shippingAddress)=>{
        try {
            if ((shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.countryCode) !== country) {
                return {
                    isPaymentDataValid: false,
                    error: {
                        reason: 'SHIPPING_ADDRESS_INVALID',
                        message: getLabel('checkout.express.google.pay.errors.invalid.address'),
                        intent: 'SHIPPING_ADDRESS'
                    }
                };
            }
            if (!isPostalCodeValid(shippingAddress.countryCode, shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.postalCode)) {
                return {
                    isPaymentDataValid: false,
                    error: {
                        reason: 'SHIPPING_ADDRESS_INVALID',
                        message: getLabel('checkout.address.postalCode.errorMessage'),
                        intent: 'SHIPPING_ADDRESS'
                    }
                };
            }
            return {
                isPaymentDataValid: true
            };
        } catch (e) {
            // Swallow InvalidAccessError
            if (!(e instanceof Error && e.name === 'InvalidAccessError')) {
                throw e;
            }
            return {
                isPaymentDataValid: true
            };
        }
    };
};

export { useValidateShippingData };
//# sourceMappingURL=use-validate-shipping-data.js.map
